import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { handleCursos } from '../../api/curso';
import { retrieveToken } from '../../hooks/use-token';

export const getCursos = createAsyncThunk(
    'cursosSlice/getUsers',
    async () => {

      const tokenApi = retrieveToken();
      return await handleCursos(tokenApi);
      
    }
);

const initialState = {
    status: null,
    data: []
}

const cursosSlice = createSlice({
    name: 'cursosSlice',
    initialState,
    extraReducers: {
      [getCursos.pending]: (state) => {
        state.status = 'Pending';
      },
      [getCursos.fulfilled]: (state, action) => {
        console.log('Fulfilled');
        console.log(action.payload);
        state.status = 'Fulfilled';
        state.data = action.payload;
      },

      [getCursos.rejected]: (state) => {
        state.status = 'Rejected';
      }
    }
});

export default cursosSlice.reducer;